import { Helmet } from 'react-helmet-async';
import { twitterHandle } from '@/lib/socials';

interface SEOProps {
  title?: string;
  description?: string;
  ogImage?: string;
  canonicalUrl?: string;
  robots?: string;
  structuredData?: object | object[];
}

export default function SEO({
  title = "Joylo: AI App Builder with Human Engineers Built In",
  description = "Joylo is the only AI app builder with real engineers behind you, whether you're stuck building, launching to production, or once real users show up.",
  ogImage = "https://joylo.ai/og/logo.png",
  canonicalUrl = "https://joylo.ai",
  robots = "index, follow, max-image-preview:large, max-snippet:-1",
  structuredData,
}: SEOProps) {
  const ogImageAlt = title.replace(/\s*\|.*$/, '');
  const schemas = structuredData
    ? (Array.isArray(structuredData) ? structuredData : [structuredData])
    : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      <meta name="robots" content={robots} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Joylo" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={ogImageAlt} />
      <meta property="og:locale" content="en_IE" />

      {/* Twitter / X */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={twitterHandle} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:image:alt" content={ogImageAlt} />

      {schemas.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
